import { Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import {
  number,
  regex,
  required,
  TextInput,
  useDataProvider,
} from "react-admin";
import { useField } from "react-final-form";

const PriceInput = () => {
  const [customerLedger, setCustomerLedger] = useState<ICustomerLedger>();

  const invoiceNo = useField("invoiceNo");
  const type = useField("type");
  const provider = useDataProvider();

  useEffect(() => {
    if (type.input.value === "credit_note") {
      if (invoiceNo.input.value !== "") {
        provider
          .customGetOne(`invoices/${invoiceNo.input.value}`)
          .then(({ data }: any) => {
            console.log(data);
            setCustomerLedger(data);
          });
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceNo.input.value]);

  const priceValidation = (value: any, allValues: any) => {
    if (Number(value) > customerLedger.amountDue / 100) {
      return "Price cannot exceed the remaining amount!";
    }
    return null;
  };

  return (
    <>
      {type.input.value === "credit_note" && invoiceNo.input.value ? (
        <>
          <TextInput
            label="Price"
            source="price"
            validate={
              customerLedger && [
                priceValidation,
                number(),
                regex(/^\d+(?:\.\d{1,2})?$/),
                required(),
              ]
            }
            disabled={!customerLedger && true}
          />
          {customerLedger && (
            <Typography variant="caption">
              Remaining Amount: ${" "}
              {(customerLedger.amountDue / 100).toLocaleString()}
            </Typography>
          )}
        </>
      ) : (
        <TextInput
          label="Price"
          source="price"
          validate={[number(), regex(/^\d+(?:\.\d{1,2})?$/), required()]}
        />
      )}
    </>
  );
};

export default PriceInput;
